import { render, staticRenderFns } from "./SideNavSectionTitle.vue?vue&type=template&id=77f78c04&scoped=true&"
import script from "./SideNavSectionTitle.vue?vue&type=script&lang=ts&"
export * from "./SideNavSectionTitle.vue?vue&type=script&lang=ts&"
import style0 from "./SideNavSectionTitle.vue?vue&type=style&index=0&id=77f78c04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f78c04",
  null
  
)

export default component.exports